import * as React from "react";
import ReactTable from "react-table";
import { FiltroAdminParametros, Parametro } from "../modelo/AdminParametro";
import { OverlayTrigger, Tooltip, Glyphicon } from "react-bootstrap";
import ModalAdminParametros from "./ModalAdminParametros";


export default class TablaAdminParametros extends React.Component<TablaAdminParametrosProps, any> {

    columns = [{
        id: "codigo",
        Header: "Codigo",
        accessor: "codigo",
        Cell: props => (this.renderTexto(props)),
        width: 275
    }, {
        id: "valor1",
        Header: "Primer Valor",
        accessor: "valor1",
        Cell: props => (this.renderTexto(props)),
        width: 175
    }, {
        id: "valor2",
        Header: "Segundo Valor",
        accessor: "valor2",
        Cell: props => (this.renderTexto(props)),
        width: 175
    }, {
        id: "valor3",
        Header: "Tercer Valor",
        accessor: "valor3",
        Cell: props => (this.renderTexto(props)),
        width: 175
    }, {
        id: "dniIngresa",
        Header: "Usuario Ingresa",
        accessor: "dniIngresa",
        Cell: props => (this.renderTexto(props)),
        width: 100
    }, {
        id: "fechaIngresa",
        Header: "Fecha Ingresa",
        accessor: "fechaIngresa",
        Cell: props => (this.renderTexto(props)),
        width: 100
    }, {
        id: "codigo",
        Header: "Acción",
        accessor: "codigo",
        Cell: props => (this.renderAccion(props)),
        width: 100
    }
    ];

    renderAccion = (props: any) => {
        if (props.original.pendiente) {
            return (
                <button type="button" className="btns btns-glyphicon">
                    <span className="icons-table">
                        <Glyphicon glyph={"transfer"} />
                    </span>
                </button>
            );
        } else {
            return (
                <ModalAdminParametros
                    codigo={props.original.codigo}
                    valor1={props.original.valor1}
                    valor2={props.original.valor2}
                    valor3={props.original.valor3}
                    valor4={props.original.valor4}
                    dniIngresa={props.original.dniIngresa}
                    fechaIngresa={props.original.fechaIngresa}
                />
            );
        }
    }

    render() {
        const { parametros, paginas, tamanoPagina, paginaActual } = this.props;
        let numRegistros = 0;

        if (parametros.length < tamanoPagina) {
            numRegistros = parametros.length;
        } else {
            numRegistros = tamanoPagina;
        }
        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{parametros.length}</span> Parámetros encontrados
                    </h2>
                </div>
                <ReactTable data={parametros}
                    columns={this.columns}
                    manual
                    defaultPageSize={numRegistros}
                    pageSizeOptions={this.calcularOpciones(numRegistros)}
                    page={paginaActual}
                    sortable={false}
                    resizable={false}
                    previousText={"Anterior"}
                    nextText={"Siguiente"}
                    loadingText={"Cargando..."}
                    noDataText={"No se ha encontrado información."}
                    pageText={"Página"}
                    ofText={"de"}
                    rowsText={""}
                    className={"-highlight -striped"}
                    pages={paginas}
                    onPageChange={(pageIndex) => {
                        this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                        this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                    }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const filtroDocumento: FiltroAdminParametros = {
            codigo: this.props.filtro.codigo,
            valor: this.props.filtro.valor,
            fecha: this.props.filtro.fecha,
            complementoFecha: this.props.filtro.complementoFecha,
            tamanoPagina: pageSize ? pageSize : tamanoPagina,
            paginaActual: pageIndex,
        };
        this.props.consultaPaginada(filtroDocumento);
    }

    calcularOpciones(tamanoPagina: number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if (elemento) {
            return arreglo;
        } else {
            return [...arreglo, tamanoPagina].sort((a, b) => { return a - b; });
        }
    }

    renderTexto = (props: any) => {
        if (props.value) {
            if (props.value.length > 20) {
                const tooltip = (
                    <Tooltip id="tooltip" className="tooltip-pos" arrowOffsetTop={20}>{props.value}</Tooltip>
                );
                return (
                    <div style={{ marginTop: '10px' }}>
                        <OverlayTrigger placement="top" overlay={tooltip}>
                            <span>{props.value}</span>
                        </OverlayTrigger>
                    </div>
                );
            }
            return (
                <div style={{ marginTop: '10px' }}>
                    <span>{props.value}</span>
                </div>
            );
        }
        return (props.value);
    }
}

interface TablaAdminParametrosProps {
    parametros: Array<Parametro>
    filtro: FiltroAdminParametros,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    consultaPaginada?: (filtro: FiltroAdminParametros) => void;
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_parametros/componentes/TablaAdminParametros.tsx